var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"CollapseButton",on:{"click":function($event){return _vm.changeShowFullMenuBar()}}},[_c('img',{attrs:{"src":require("@/assets/navigation-menu-1.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }